import React from 'react'

// New work - no counterpart in the source design (see the OUR WORK banner in
// src/css/site/site.css for the CSS built for it). Built on primitives already in
// site.css: `.section`/`.container`/`.section-eyebrow`/`.section-title`, per the task brief.
const OurWork = ({ block }) => (
    <section className="section" id="work">
        <div className="container">
            <div className="section-eyebrow">{block.eyebrow}</div>
            <h2 className="section-title">{block.title}</h2>
            <div className="nv-work-grid">
                {block.images.map((src, i) => (
                    <div className="nv-work-card" key={i}>
                        <img src={src} alt={block.title + ' ' + (i + 1)} />
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default OurWork;
